<template>
  <div class="merge-gz">
    <Modal
      v-model="modal"
      title="工资发送核对"
      :width="700"
      :footer-hide="true"
      :closable="false"
    >
      <p style="margin-bottom: 6px">
        ①审批即表示对本次教师考勤的工资确认无误，请根据实际情况进行审批操作。如果设置成通过，该操作不可恢复，是否确认该操作？
      </p>
      <p style="margin-bottom: 6px">
        ②发送后，平台将提交工资发放至银行进行处理，具体时间请以银行实际处理时间为准。
      </p>
      <p style="margin-bottom: 16px">
        ③工资到账后，教师可通过提现，将工资提现到自己的银行卡中
      </p>
      <div class="count">
        <p style="width: 50%">
          实发放人数:
          <span style="color: #2db7f5">{{ cfmCountNum.confirmedNum }}</span
          >人
        </p>
        <p>
          实发放总金额:
          <span style="color: #d9001b">{{ abs(cfmCountNum.realAmt) }}</span
          >元
        </p>
      </div>
      <div class="modal-430-bottom">
        <Button @click="handleCancle">取消</Button>
        <Button type="primary" @click="handleSubmit">确定</Button>
      </div>
    </Modal>
    <SendSmsForMerchants
      ref="sendSmsForMerchantsRef"
      :sheetId="sheetId"
      :phoneNo="phoneNo"
      @on-finish="onSendSmsFinish"
    ></SendSmsForMerchants>
  </div>
</template>

<script>
import SendSmsForMerchants from './SendSmsForMerchants.vue'
import financeCenterApi from '@/request/financeCenter/index.js';
import { abs } from '@/utils/utils.js'
export default {
  name: 'sendCheckGz',
  components: {
    SendSmsForMerchants
  },
  props: {
    cfmCountNum: {
      type: Object,
      default: () => {
        return {
          abolishNum: 0,
          confirmedNum: 0,
          schoolConfirmNum: 0,
          unconfirmedNum: 0,
          realAmt: 0,
        }
      }
    },
    schoolId: {
      type: String,
      default: ''
    },
    sheetId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      modal: false,
      phoneNo: ''
    }
  },
  created() {

  },
  methods: {
    abs(num) {
      return abs(num)
    },
    // // 关联资管平台的商户管理员的手机号码
    async getMerchantsAdministratorInfo() {
      let res = await financeCenterApi.getMerchantsAdministratorInfoApi({
        schoolId: this.schoolId
      })
      if (res.status == 200) {
        this.phoneNo = res.message
      }
    },
    async setFinancialConfirmed(sheetSts, phoneCode) {

      this.$Spin.show();
      let res = await financeCenterApi.setFinancialConfirmedApi({ sheetId: this.sheetId, verifyCode: phoneCode, sheetSts: sheetSts })
      this.$Spin.hide();
      if (res.status == 200) {
        this.modal = false
        this.$refs.sendSmsForMerchantsRef.handleHide()
        this.$Modal.success({
          title: '温馨提示',
          content: `工资发放操作成功！请稍后查看结算状态！`
        });
        this.$emit('on-check-finish')
      }
    },
    onSendSmsFinish(data) {
      this.setFinancialConfirmed(3, data.phoneCode)
    },
    handleShow() {
      this.modal = true
      if (!this.phoneNo) {
        this.getMerchantsAdministratorInfo()
      }

    },
    handleCancle() {
      this.modal = false
    },
    handleSubmit() {
      if (this.cfmCountNum.realAmt == 0) {
        this.$Message.warning('实发工资需大于0 ，请重新核对');
        return null
      }
      this.$refs.sendSmsForMerchantsRef.handleShow()
    }
  }
}
</script>

<style lang="scss" scoped>
.count {
  display: flex;
  font-size: 18px;
  font-weight: bold;
}
</style>